import React, { useState } from 'react';
import { evoke, impulses, toHex } from '../constants'
import BehaviourButton from '../BehaviourButton'
import ImpulseButton from '../ImpulseButton'
import { useDispatch, useSelector } from 'react-redux'
import {selectImpulseButtonTexts, selectImpulse } from '../behaviourControlsSlice';
import TeachRTooltip from "../../../components/Tooltip/TeachRTooltip" 

const ImpulseControls = () => {
    let impulseButtonTexts = useSelector(selectImpulseButtonTexts)

    const impulse = useSelector(selectImpulse);
    // save last selected impulse type (positive, neutral, negative)
    const [selectedImpulse, setSelectedImpulse] = useState(null); 

    const getImpulseText = (impulseType) => {
        console.log('impulseButtonTexts:', impulseButtonTexts);
        const impulseText = impulseButtonTexts.find(text => text.startsWith(impulseType));
        console.log('impulseText:', impulseText);
        return impulseText ? impulseText.split(':')[1] : "";
    }

    const circleStyle = {
        display: 'inline-block',
        width: '24px',
        height: '24px',
        lineHeight: '20px',
        borderRadius: '50%',
        textAlign: 'center',
        marginRight: '8px',
        flexShrink: 0,
        fontSize: '1.8em',
        fontWeight: 'bold'
    };

    const descriptionTextStyle = {
        height: 'auto',
        minHeight: '25px',
        width: '100%',
        padding: '4px',
        resize: 'none',
        overflow: 'hidden' // hide scrollbar
    };

    const calculateRows = (text, charsPerRow = 47) => {
        return Math.ceil(text.length / charsPerRow) || 1;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', flex: 0 }}>
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                {/* Impulses column */}
                <h4>Impulses
                    <TeachRTooltip
                        content={
                            <div>
                                <p>Hotkeys:</p>
                                <ul>
                                    <li>q - positive impulse</li>
                                    <li>w - neutral  impulse</li>
                                    <li>e - negative impulse</li>
                                    <li>r - evoke</li>
                                    <li>s - trigger idle animation</li>
                                    <li>a - select/deselect all students</li>
                                </ul>
                            </div>
                        }
                        icon="info-sign"
                        iconColor="var(--highlight_1)"
                        tooltipDirection="bottom"
                        style={{ marginLeft: '14px' }}
                    /></h4>
                <div className="d-flex">
                    <div className="btn-group-vertical my-2 flex-grow-1">
                        <div className="btn-group">
                            {/* ImpulseButton for impulses */}
                            {impulses.map((i) => (
                                <ImpulseButton
                                    key={i}
                                    impulse={i}
                                    type="impulse"
                                    setSelectedImpulse={setSelectedImpulse}
                                />
                            ))}
                        </div>
                        <div className="btn-group">
                            {/* BehaviourButton for evoke */}
                            {evoke.map((j) => (
                                <BehaviourButton
                                    key={j}
                                    behaviour={j}
                                    type="impulse"
                                    selectedImpulse={selectedImpulse}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="col-md-7"> {/* Description column */}
                <h4>Impulse Descriptions</h4>
                <div>
                    {/* Positive */}
                    <div className="mb-2 d-flex align-items-center">
                        <label className="d-flex align-items-center mb-0 mr-2">
                            <span style={{ ...circleStyle, border: `1px solid ${toHex.success}`, color: toHex.success }}> + </span>
                        </label>
                        <textarea
                            readOnly
                            value={getImpulseText('positive')}
                            className="form-control flex-grow-1"
                            style={descriptionTextStyle}
                            rows={calculateRows(getImpulseText('positive'))}
                        />
                    </div>
                    {/* Neutral */}
                    <div className="mb-2 d-flex align-items-center">
                        <label className="d-flex align-items-center mb-0 mr-2">
                            <span style={{ ...circleStyle, border: `1px solid ${toHex.warning}`, color: toHex.warning }}> ~ </span>
                        </label>
                        <textarea
                            readOnly
                            value={getImpulseText('neutral')}
                            className="form-control flex-grow-1"
                            style={descriptionTextStyle}
                            rows={calculateRows(getImpulseText('neutral'))}
                        />
                    </div>
                    {/* Negative */}
                    <div className="mb-2 d-flex align-items-center">
                        <label className="d-flex align-items-center mb-0 mr-2">
                            <span style={{ ...circleStyle, border: `1px solid ${toHex.danger}`, color: toHex.danger }}> - </span>
                        </label>
                        <textarea
                            readOnly
                            value={getImpulseText('negative')}
                            className="form-control flex-grow-1"
                            style={descriptionTextStyle}
                            rows={calculateRows(getImpulseText('negative'))}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImpulseControls
